export default "<button type=\"button\" class=\"btn btn-info\"\r\n        [popover]=\"content\" [popoverTitle]=\"title\">\r\n  Simple binding\r\n</button>\r\n";